import { PropsWithChildren } from 'react';

import { StyledProps } from '@ui-furniture/style';

import { Text } from '../text';

export const CardTitle = (props: PropsWithChildren<StyledProps>) => (
  <Text as='h3' fontSize='lg' fontWeight='600' {...props} />
);

export const CardSubtitle = (props: PropsWithChildren<StyledProps>) => (
  <Text
    as='h4'
    color='palette-primary'
    fontSize='md'
    fontWeight='600'
    {...props}
  />
);
